// EXPERIMENT #171200783
// Set webpack asset host at runtime. Must be imported at top of entrypoints.
import '../helpers/asset_host';
import ReactComponentRegistry from 'react_component_registry';
import SurveySignupModal from 'components/survey_signup_modal';
import SurveyManager from 'components/survey_signup_modal/components/survey_manager';
import HomepageSignupForm from 'components/survey_signup_modal/components/homepage_signup_form';
import toggleModalVisibility from 'components/survey_signup_modal/visibility';

const isModalVisible = () => {
  const modalWrapper = document.querySelector('#survey-signup-modal-wrapper.modal-wrapper');
  return modalWrapper && !modalWrapper.classList.contains('hide');
};

const setupModal = () => {
  // Show modal on main CTA clicks
  document.querySelectorAll('.survey-signup-modal-tag').forEach(node => {
    const closestAnchor = node.closest('a');
    // Some tags will be wrapped in <button> instead
    if (closestAnchor) {
      closestAnchor.addEventListener('click', e => {
        e.preventDefault(); // Don't follow a redirect
        toggleModalVisibility(closestAnchor.href, false);
      });
    }
  });

  // Hide modal when clicking the background
  const modalBackground = document.querySelector(
    '#survey-signup-modal-wrapper .bg-dark.modal-background'
  );
  if (modalBackground) {
    modalBackground.addEventListener('click', toggleModalVisibility);
  }

  // Hide modal when pressing escape
  document.body.addEventListener('keydown', ({ key }) => {
    if (isModalVisible() && key === 'Escape') {
      toggleModalVisibility();
    }
  });

  // Show modal if show survey modal in query params
  const currentQueryParams = Object.fromEntries(new URL(window.location.href).searchParams);
  // When coming back from Google SSO, we want to open modal by default
  if (currentQueryParams && currentQueryParams.from_google_sso === 'true') {
    // Find first cta button
    // Does this work if its from pricing?
    const closestCta = document.querySelector('.survey-signup-modal-tag');
    if (closestCta) {
      const closestAnchor = closestCta.closest('a');
      toggleModalVisibility(closestAnchor.href, true);
    }
  }
};

window.addEventListener('DOMContentLoaded', setupModal, { once: true });

ReactComponentRegistry.register({ SurveySignupModal, SurveyManager, HomepageSignupForm });
